import { usePermissionStore } from "../store/usePermissionStore";
import { SeedModule, RolePermissions } from "../types/api";

export const hasModuleAccess = (
  // permissions: RolePermissions,
  seedModules: SeedModule[],
  moduleKey: string,
  user: any
): boolean => {
  if (user?.roles.includes("orgadmin")) {
    return true;  // not superadmin
  }
  const permissions = usePermissionStore.getState().permissions;

  const module = seedModules.find((mod) => mod.key === moduleKey);
  if (!module) return false;

  return module.subModules.some(
    (subMod: any) => permissions[subMod.key] && permissions[subMod.key].size > 0
  );
};

// Check if user has access to a submodule and specific action
export const hasActionAccess = (
  // permissions: RolePermissions,
  subModuleKey: string,
  action: string
): boolean => {
  const permissions = usePermissionStore.getState().permissions;
  return permissions[subModuleKey]?.has(action);
};
